<template>
	<div class="bg-login">
		<div class="contenedor" >
			<div>
				<div class="card text-left" style="border-radius: 5px;box-shadow: 0 0 40px rgba(0,0,0,0.2)">
					<div class="card-header bg-danger text-white">
						<div class="row">
							<div class="col text-left pt-2">
								<span style="font-size:1.4em;">
									<span class="fa fa-lock mr-2"></span>
									Restaurar contraseña
								</span>
							</div>
							<div class="col text-right">
								<img src="/static/recursos/logo_sip_white.svg" alt="logo" style="height:40px;">
							</div>
						</div>
					</div>
					<div class="card-body">
						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<span class="fa fa-user"></span>
								</span>
							</div>
							<input type="password" class="form-control" placeholder="Contraseña" v-model="form.password">
						</div>

						<div class="input-group mb-4">
							<div class="input-group-prepend">
								<span class="input-group-text">
									<span class="fa fa-lock"></span>
								</span>
							</div>
							<input type="password" class="form-control" placeholder="Repítela" v-model="form.password2" @keypress.enter="cambiar">
						</div>
					</div>
					<div class="card-footer">
						<button class="btn btn-sm btn-warning btn-block" @click="cambiar">
							Cambiar
						</button>
					</div>
				</div>
				<div class="alert alert-danger text-left mt-2">
					<b style="font-size:1.2em;text-transform: uppercase;">Atención</b>
					<p>
						Este sitio está reservado única y exclusivamente para el <b>personal de Radio Castellón S.A.</b> Si no estás autorizado a entrar, debes
						abandonar inmediatamente esta página.
					</p>
				</div>
			</div>
		</div>
	</div>
</template>
<script>

import axios from 'axios'

export default {
	data () {
		return {
			form: {
				idUsuario: null,
				token: null,
				password: '',
				password2: ''
			}
		}
	},

	created () {
		// Ahora obtenemos de la ruta las variables
		this.form.idUsuario = this.$route.params.idUsuario
		this.form.token = this.$route.params.token
	},

	methods: {
		cambiar () {
			if (this.form.password !== this.form.password2) {
				this.$store.commit('alertas/error', {
					titulo: 'Error',
					mensaje: 'Las contraseñas no coinciden'
				})
				return
			}
			axios.post('core/php/api/password-restore/update.php', this.form)
				.then(res => {
					this.$store.commit('alertas/alert', {
						titulo: 'Contraseña actualizada',
						mensaje: `Se ha actualizado tu contraseña correctamente.`,
						callback: () => {
							this.$router.push('/login')
						}
					})
				})
				.catch(e => {
					this.$store.commit('alertas/error', {
						titulo: 'Error',
						mensaje: e.response.data.error
					})
				})
		}
	}
}
</script>


<style scoped>
	.bg-login {
		position: fixed;
		display: block;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		overflow: auto;
		background-image: url('./bg.jpg');
		background-size: cover;
		background-position: center;
		background-repeat: no-repeat;
	}

	.contenedor {
		position: relative;
		display: block;
		text-align: center;
	}

	.contenedor > div {
		position: relative;
		display: inline-block;
		max-width: 500px;
		width: 90%;
		margin-top: 50px;
	}
</style>



// WEBPACK FOOTER //
// src/modulos/core/vue/components/password-restore/password-restore.vue